import GeoJSON from "ol/format/GeoJSON";
import { FeatureType } from "@/geoMap/define/FeatureType";
import { IAttributeConvert } from "./IAttributeConvert";
import { AttributeView } from "./AttributeView";
import { ExportValue } from "./ExportValue";
import { AttributeValue } from "./AttributeValue";

const FEATURE_TYPE = FeatureType.GeoJson;

/**
 * 画面幅
 */
const VALUE_WIDTH = 300;

/**
 * 画面高さ
 */
const VALUE_HEIGHT = 620;

/**
 * 画面最大高さ
 */
const VALUE_MAX_HEIGHT = 620;

/**
 * 出力JSONファイル名
 */
const VALUE_JSON_FILE_NAME = "";

/**
 * 出力CSVファイル名
 */
const VALUE_CSV_FILE_NAME = "";

/**
 * タイトル
 */
const VALUE_TITLE = "GeoJSON属性表示";

/**
 * スタイル属性プロパティリスト
 */
const STYLE_PROPERTIES = [
  "_markerType",
  "_className",
  "_stroke",
  "_color",
  "_weight",
  "_opacity",
  "_fill",
  "_fillColor",
  "_fillOpacity",
  "_dashArray",
  "_lineCap",
  "_lineJoin",
  "_clickable",
  "_iconUrl",
  "_iconSize",
  "_iconAnchor",
  "_html",
  "_radius",
];

export class GeoJsonAttributeConvert implements IAttributeConvert {
  private _geoJson: any;

  constructor(geoJson: any) {
    this._geoJson = geoJson;
  }
  getFeatureType(): FeatureType {
    return FEATURE_TYPE;
  }

  getViewFormatData(): AttributeView {
    const feature = new GeoJSON().readFeature(this._geoJson);
    const properties = feature.getProperties();
    let attributeIndex = 0;
    const attributeValues = Object.keys(properties)
      .map((key: string) => {
        if (key === "geometry" || STYLE_PROPERTIES.includes(key)) return;
        attributeIndex++;
        return new AttributeValue(
          key,
          typeof properties[key] === "number"
            ? properties[key].toString()
            : properties[key],
          attributeIndex <= 9
        );
      })
      .filter((e) => e);
    return new AttributeView(
      attributeValues,
      VALUE_TITLE,
      VALUE_WIDTH,
      VALUE_HEIGHT,
      VALUE_MAX_HEIGHT
    );
  }

  /**
   * ファイル出力用項目取得
   */
  getExportValue(): ExportValue {
    const feature = new GeoJSON().readFeature(this._geoJson);
    feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
    const attributeValues = this.getViewFormatData().attributeValues;
    return new ExportValue(
      feature,
      attributeValues,
      VALUE_JSON_FILE_NAME,
      VALUE_CSV_FILE_NAME
    );
  }
}
